<template>

  <Previsionale />

</template>

<script>
import Previsionale from '../components/pratiche/Previsionale.vue'

export default {
  components: {
    Previsionale
  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
